import React from "react";
import LeftForm from "../../Components/Forms/LeftForm";
import RightTable from "../../Components/Tables/RightTable";
import UserForm from "../../Components/Forms/LeftFormInputs";

const leftColumns = [
  [
    {
      Header: "Identifiant",
      accessor: "username",
      inputType: "text",
      required: true
    },
    {
      Header: "Mot de passe",
      accessor: "password",
      inputType: "text",
      required: true
    },
    {
      Header: "Type",
      accessor: "user_type",
      inputType: "select",
      required: true,
      options: [
        { key: "employee", value: "Employé" },
        { key: "vendeur", value: "Vendeur" },
        { key: "captain", value: "Chef d'Équipe" },
        { key: "admin", value: "Administrateur" }
      ]
    }
  ]
];

const rightColumns = [
  {
    Header: "Nom",
    accessor: "username"
  },
  {
    Header: "Type",
    accessor: "user_type",
    filterable: false,
    Cell: row => {
      let type = "";
      switch (row.value) {
        case "employee":
          type = "Employé";
          break;
        case "vendeur":
          type = "Vendeur";
          break;
        case "captain":
          type = "Chef d'Équipe";
          break;
        case "admin":
          type = "Administrateur";
          break;
        default:
          type = "";
          break;
      }
      return <div className="user-type">{type}</div>;
    }
  }
];

const Users = () => (
  <React.Fragment>
    <LeftForm title="Créer un nouvel utilisateur" model="users">
      <UserForm model="users" columns={leftColumns} />
    </LeftForm>
    <RightTable
      title="Liste d'utilisateurs"
      model="users"
      columns={rightColumns}
    />
  </React.Fragment>
);

export default Users;
